var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationImportant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Important_svg__clip0_16517_21016)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Important_svg__clip1_16517_21016)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.318 15.56H5.566l4.496-3.672 2.072 1.456 2.064-1.48a9.976 9.976 0 011.568-1.112l3.072-2.2v1.264c.168-.016.344-.024.52-.024.256 0 .504.016.744.04V6.4H3.99v10.424h8.192c0-.432.048-.856.128-1.264h.008zm5.568-7.896l-5.76 4.144L6.31 7.664h11.576zm-12.632.8l3.744 2.672-3.744 3.056V8.464zM18.902 11.04l-4.944 8.672h9.888l-4.944-8.672zm-.344 2.776c0-.096.04-.184.104-.248a.351.351 0 01.248-.104c.096 0 .184.04.248.104a.351.351 0 01.104.248v2.776c0 .096-.04.184-.104.248a.351.351 0 01-.248.104.351.351 0 01-.248-.104.351.351 0 01-.104-.248v-2.776zm.344 5.024a.53.53 0 01-.48-.32.562.562 0 01-.032-.304.48.48 0 01.144-.264.572.572 0 01.264-.144.501.501 0 01.304.032.53.53 0 01.32.48.528.528 0 01-.152.368.528.528 0 01-.368.152z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Important_svg__clip0_16517_21016"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-.01)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Important_svg__clip1_16517_21016"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.99 6.4)",
    d: "M0 0h19.864v13.312H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/Notification_Important.7071d438.svg";
export { SvgNotificationImportant as ReactComponent };